import { environment } from 'src/environments/environment';

class Logger {
  /**
   * Logs a message and data to the console if the application is not in production mode.
   *
   * @template T - The type of the data to be logged.
   * @param {T} data - The data to be logged.
   * @param {string} description - The message to be logged alongside the data.
   */
  log<T>(data: T | null, description: string) {
    if (!environment.production) {
      if (data) {
        console.log(description, data);
      } else {
        console.log(description);
      }
    }
  }
}

export const logger = new Logger();
